import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import LeftNavigationPanel from '../navigation/leftNavigationPanel';
import MainPanel from '../navigation/mainPanel';

const MainWrapper = () => {
  const user = useSelector(state => state.user);

  const [daysLeft, setDaysLeft] = useState(0);
  const [hoursLeft, setHoursLeft] = useState(0);
  const [minutesLeft, setMinutesLeft] = useState(0);

  // Calculates the remaining time
  const calculateTimeLeft = () => {
    if (!user || !user.trial_start || !user.trial_end || user.trial_over) return;

    const now = new Date();
    const end = new Date(user.trial_end);
    const diffMs = end - now;

    if (diffMs > 0) {
      setDaysLeft(Math.floor(diffMs / (1000 * 60 * 60 * 24)));
      setHoursLeft(Math.floor((diffMs / (1000 * 60 * 60)) % 24));
      setMinutesLeft(Math.floor((diffMs / (1000 * 60)) % 60));
    } else {
      setDaysLeft(0);
      setHoursLeft(0);
      setMinutesLeft(0);
    }
  };

  useEffect(() => {
    if (!user || !user.trial_start || !user.trial_end || user.trial_over) return;

    calculateTimeLeft();

    // Update countdown every hour
    const countdownInterval = setInterval(calculateTimeLeft, 60 * 60 * 1000);
    return () => clearInterval(countdownInterval);
  }, [user]);

  return (
    <div style={{ zIndex: '50', position: 'relative' }}>
      {/* TOP TRIAL BANNER (only if trial is active) */}
      {user && user.trial_over === false && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '28px',
            backgroundColor: '#000',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 20px',
            zIndex: 9999,
            fontSize: '15px',
            fontWeight: 'bold',
            boxSizing: 'border-box',
          }}
        >
          <div>
            FULL TRIAL ACCESS — Ends in: {daysLeft}d {hoursLeft}h
          </div>
          &nbsp;
          &nbsp;
          <NavLink
            to="/accounts"
            style={{
              color: '#00b3b5',
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            Ready to Sign Up?
          </NavLink>
        </div>
      )}

      <LeftNavigationPanel />
      <MainPanel />
    </div>
  );
};

export default MainWrapper;
